// extracted by mini-css-extract-plugin
module.exports = {"icon":"ExperimentalCallOut-icon-bd96336a3706fa1d62c1b4f72f8c777b","title":"ExperimentalCallOut-title-26e6e68aaeae84c652eb5f78f29813e3"};